/* eslint-disable no-restricted-globals */
export default () => {
  self.addEventListener("message", (event) => {
    if (!event) return;
    const {
      userCips,
      cips,
      cleaningEffectiness,
      fouling,
      predictionandRecommendData,
      predictionDataRaw,
      others,
      totalbenefitWindow,
      annualBenefitsWindow,
    } = event.data.exportData;
    const { exportWorkerTransaltionString } = event.data.translations;
    const foulingType = event.data.foulingType;

    const getLanguageCode = {
      USD: {
        code: "en-US",
        currency: "USD",
        symbol: "$",
      },
      Yuan: {
        code: "zh-CN",
        currency: "CNY",
        symbol: "元",
      },
      Euro: {
        code: "EUR",
        currency: "EUR",
        symbol: "€",
      },
    };

    const multipleReasonFormatter = (type) => {
      if (typeof type === "string") {
        type = type.split(",");
      }
      if (Array.isArray(type)) {
        const formattedType = type.map((item) => {
          const trimmedItem = item.trim();
          return trimmedItem;
        });
        const resultString = formattedType.join(", ");
        return resultString;
      }
      return type;
    };
    const reasonFormatter = (data, isPrimary = true) => {
      let reason = "";
      if (data.length === 0) {
        reason = "Tool did not identify any strong reason.";
      } else
        reason = isPrimary
          ? foulingType[data[0].primary_reason]
          : foulingType[data[0].secondary_reason];

      return reason;
    };

    const pressureFormatter = (value) => {
      const hasSuperscriptA = typeof value === "string" && value.includes("ᵃ");
      const hasSuperscriptB = typeof value === "string" && value.includes("ᵇ");

      const numericValue =
        hasSuperscriptA || hasSuperscriptB
          ? parseFloat(value.replace("ᵃ", "").replace("ᵇ", "").trim())
          : parseFloat(value);

      if (isNaN(numericValue)) {
        return "*";
      } else if (numericValue < 0) {
        return hasSuperscriptA ? "< 0 ᵃ" : hasSuperscriptB ? "< 0 ᵇ" : "< 0";
      } else if (numericValue > 100) {
        return hasSuperscriptA
          ? "> 100 ᵃ"
          : hasSuperscriptB
          ? "> 100 ᵇ"
          : "> 100";
      } else {
        return (Math.floor(numericValue * 10) / 10).toFixed(1);
      }
    };

    const dateFormatter = (date) => {
      if (date) {
        date = new Date(date);

        if (isNaN(date.getTime())) {
          return "Invalid Date";
        }
        const formattedDay = date.getDate().toString().padStart(2, "0");
        const formattedMonth = (date.getMonth() + 1)
          .toString()
          .padStart(2, "0");
        const formattedYear = date.getFullYear();

        return `${formattedDay}/${formattedMonth}/${formattedYear}`;
      } else return null;
    };

    const typeFormatter = (type, value) => {
      type =
        type === null
          ? ""
          : type?.toLowerCase() === value.toLowerCase()
          ? exportWorkerTransaltionString.cip
          : exportWorkerTransaltionString.shutDown;
      return type;
    };

    const formattedCurrencyValue = (value) => {
      let formattedValue = value;
      const currency = others[0].currency;
      const languageCurrency = getLanguageCode[currency].currency;
      const currencySymbol = getLanguageCode[currency].symbol;
      const currencyCode = getLanguageCode[currency].code;

      if (value) {
        value = Math.floor(value);
        formattedValue = value.toLocaleString(currencyCode, {
          style: "currency",
          currency: languageCurrency,
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        });
      }
      if (currencyCode === "zh-CN" && formattedValue)
        formattedValue = formattedValue.replace("¥", "元");
      return formattedValue === 0
        ? `${currencySymbol}${formattedValue}`
        : formattedValue;
    };

    const formatDecimal = (value) => {
      value = parseFloat(value);
      return value > 0 ? value.toFixed(2) : value.toFixed(0);
    };

    const cipSheetData = cips?.map((data, index) => {
      return {
        ...data,
        index: index + 1,
        start_date: dateFormatter(data.start_date),
        end_date: dateFormatter(data.end_date),
        type: typeFormatter(data.type, "C"),
        is_tool_identified: data.is_tool_identified
          ? exportWorkerTransaltionString.calculation
          : exportWorkerTransaltionString.user,
        acidPh: data.acid_cip_ph,
        acidTemperature: data.acid_cip_temp,
        acidDuration: data.acid_cip_duration,
        acidUsed: data.acid_used_per_cip,
        alkaliPh: data.alkali_cip_ph,
        alkaliTemperature: data.alkali_cip_temp,
        alkaliDuration: data.alkali_cip_duration,
        alkaliUsed: data.alkali_used_per_cip,
        solutionPh: data.cip_solution_ph,
        solutionTemperature: data.cip_solution_temp,
        solutionDuration: data.cip_solution_duration,
        solutionUsed: data.additional_chemical_per_cip,
        addInfo: data.add_info,
      };
    });

    const cleaningEffectinessSheetData = cleaningEffectiness?.map(
      (data, index) => {
        return {
          ...data,
          index: index + 1,
          type: typeFormatter(data.type, "C"),
          start_date: dateFormatter(data.start_date),
          pressure_drop: pressureFormatter(data.pressure_drop),
          flow: pressureFormatter(data.flow),
          salt_passage: pressureFormatter(data.salt_passage),
          reason: multipleReasonFormatter(data.reason),
        };
      }
    );

    const foulingSheetData = fouling?.map((data, index) => {
      return {
        ...data,
        index: index + 1,
        type: typeFormatter(data.data[0].type, "C"),
        start_date: dateFormatter(data.start_date),
        end_date: dateFormatter(data.end_date),
        primary_reason: reasonFormatter(data?.data, true),
        secondary_reason: reasonFormatter(data?.data, false),
      };
    });

    const otherSheetData = others;
    const predicitionSheetData = predictionandRecommendData?.map(
      (data, index) => {
        const predictedItem = data.predictedItem;
        const recommendedItem = data.recommendedItem;
        return {
          predictIndex: predictedItem.start_date ? index + 1 : "",
          predictType: typeFormatter(predictedItem.type, "CIP"),
          predictStart_date: dateFormatter(predictedItem.start_date),
          predictReason: multipleReasonFormatter(predictedItem.reason),
          recommendIndex: recommendedItem.start_date ? index + 1 : "",
          recommendType: typeFormatter(recommendedItem.type, "CIP"),
          recommendStart_date: dateFormatter(recommendedItem.start_date),
          recommendReason: multipleReasonFormatter(
            recommendedItem.reason_recommended
          ),
        };
      }
    );

    let benefitSheetDataMessage = "";
    let benefitSheetData = null;
    const totalFinancialBenefits = predictionDataRaw
      ? parseInt(predictionDataRaw["total_financial_benefits"])
      : 0;

    if (totalFinancialBenefits > 0) {
      benefitSheetDataMessage = `${
        exportWorkerTransaltionString.totalFinancialBenefits
      } (${totalbenefitWindow}) : ${formattedCurrencyValue(
        predictionDataRaw.total_financial_benefits
      )}`;
      benefitSheetData = [
        {
          financialEnergy: formatDecimal(
            predictionDataRaw?.energy_saving_percent
          ),
          financialEnergyCost: formattedCurrencyValue(
            predictionDataRaw?.energy_saving_dollars
          ),
          financialChemical: formatDecimal(
            predictionDataRaw?.chemical_saving_percent
          ),
          financialChemicalCost: formattedCurrencyValue(
            predictionDataRaw?.chemical_saving_dollars
          ),
          financialDownTime: formatDecimal(
            predictionDataRaw?.downtime_saving_percent
          ),
          financialDownTimeCost: formattedCurrencyValue(
            predictionDataRaw?.downtime_saving_dollars
          ),
          financialIncreasedProduction: formatDecimal(
            predictionDataRaw?.increased_production_percent
          ),
          financialIncreasedProductionCost: formattedCurrencyValue(
            predictionDataRaw?.increased_production_dollars
          ),
        },
      ];
    }

    let annualBenefitSheetDataMessage = "";
    let annualBenefitSheetData = null;
    const annualTotalFinancialBenefits = predictionDataRaw
      ? parseInt(predictionDataRaw["annual_total_financial_benefits"])
      : 0;

    if (
      predictionDataRaw?.forcast_window < 365 &&
      predictionDataRaw?.forcast_window > 183 &&
      annualTotalFinancialBenefits > 0
    ) {
      annualBenefitSheetDataMessage = `${
        exportWorkerTransaltionString.totalAnnualBenefits
      } (${annualBenefitsWindow}) : ${formattedCurrencyValue(
        predictionDataRaw.annual_total_financial_benefits
      )}`;

      annualBenefitSheetData = [
        {
          financialEnergy: formatDecimal(
            predictionDataRaw?.annual_energy_saving_percent
          ),
          financialEnergyCost: formattedCurrencyValue(
            predictionDataRaw?.annual_energy_saving_dollars
          ),
          financialChemical: formatDecimal(
            predictionDataRaw?.annual_chemical_saving_percent
          ),
          financialChemicalCost: formattedCurrencyValue(
            predictionDataRaw?.annual_chemical_saving_dollars
          ),
          financialDownTime: formatDecimal(
            predictionDataRaw?.annual_downtime_saving_percent
          ),
          financialDownTimeCost: formattedCurrencyValue(
            predictionDataRaw?.annual_downtime_saving_dollars
          ),
          financialIncreasedProduction:
            predictionDataRaw?.annual_increased_production,
          financialIncreasedProductionCost: formattedCurrencyValue(
            predictionDataRaw?.annual_increased_production_dollars
          ),
        },
      ];
    }

    postMessage({
      predicitionSheetData,
      benefitSheetDataMessage,
      annualBenefitSheetDataMessage,
      benefitSheetData,
      annualBenefitSheetData,
      cipSheetData,
      cleaningEffectinessSheetData,
      foulingSheetData,
      otherSheetData,
    });
  });
};
